import { alpha } from '@mui/material/styles';
import type { SxProps, Theme } from '@mui/material/styles';

/** Acento lila del panel de inventario (Proveedor, buscador de producto, Cantidad, "+ Agregar
 *  producto"). Nombre neutral a propósito — el color ya cambió varias veces (azul → verde → lila);
 *  si vuelve a cambiar, solo se edita este valor, nunca hay que renombrar nada. */
export const ACCENT_COLOR = '#7c3aed';

/**
 * Fuente única del borde/foco para campos de texto y Autocomplete. Antes cada campo tenía su
 * propio color a mano — algunos quedaron en el azul por defecto de MUI y otros en verde, sin
 * ningún criterio. Un solo lugar evita que se vuelvan a desalinear.
 *
 * `buildAccentFieldStyles` es el objeto plano (para usar dentro de un `styled(...)`);
 * `accentFieldSx` es la misma receta envuelta para la prop `sx` de un componente MUI suelto.
 */
export function buildAccentFieldStyles(_theme: Theme) {
  return {
    '& .MuiOutlinedInput-root': {
      transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
      '& fieldset': {
        borderColor: alpha(ACCENT_COLOR, 0.45),
        borderWidth: '1px',
      },
      '&:hover fieldset': {
        borderColor: ACCENT_COLOR,
      },
      '&.Mui-focused fieldset': {
        borderColor: ACCENT_COLOR,
        borderWidth: '2px',
      },
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: ACCENT_COLOR,
    },
  };
}

export const accentFieldSx: SxProps<Theme> = (theme) => buildAccentFieldStyles(theme);
